import isEmpty from 'lodash/isEmpty';

export function replaceKeysInString(template: string, keys: string[], values: string[]) {
  const regex = /{{(.*?)}}/g;

  return template.replace(regex, (match, key) => {
    const index = keys.indexOf(key);

    return index !== -1 ? values[index] : match;
  });
}
export function constructUrlWithQuery(template: string, queryParams: any) {
  const [_, queryPart] = template.split('?');

  if (isEmpty(queryParams)) return template;

  const queryString = new URLSearchParams(queryParams).toString();
  if (queryPart) {
    const existingQueryParams = new URLSearchParams(queryPart);
    for (const [key, value] of Object.entries<string>(queryParams)) {
      existingQueryParams.set(key, value);
    }
    return `${_}?${existingQueryParams.toString()}`;
  }

  return queryString ? `${_}?${queryString}` : template;
}
